<template>
    <div class="">
        <label class="text-sm font-semibold text-secondary-600 dark:text-darkblue-400 black:text-darkblue-500 block mb-1">{{ label }}</label>
        <span class="min-input-height flex items-center dark:text-darkblue-200 black:text-darkblue-500 dark:border-darkblue-600 whitespace-pre-wrap">{{ data }}</span>
    </div>
</template>

<script>
export default {
  name: 'read-only-input',
  props: {
    label: {
      type: String,
      default: ''
    },
    data: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .min-input-height {
    padding: .25rem 0 0.70rem 0;
  }
</style>
